import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import OwnerHeader from './OwnerHeader';
import OwnerSidebar from './OwnerSidebar';
import type { UserProfile } from '../../types/auth';
import { OwnerManproProvider } from '../context/OwnerManproContext';

type OwnerLayoutProps = {
  onLogout: () => void;
  userProfile: UserProfile | null;
};

const OwnerLayout = ({ onLogout, userProfile }: OwnerLayoutProps) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        setIsSidebarOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        setIsSidebarOpen(false);
      }
    };

    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, []);

  return (
    // Provider ini mencegah props drilling: semua halaman Owner bisa membaca data MANPRO dari satu context.
    <OwnerManproProvider>
      <div className="min-h-[125vh] bg-[#f8fafc] text-slate-900">
        {isSidebarOpen && (
          <button
            className="fixed inset-0 z-40 bg-slate-950/40 backdrop-blur-sm lg:hidden"
            onClick={() => setIsSidebarOpen(false)}
            aria-label="Tutup menu"
            type="button"
          />
        )}

        <aside
          className={`fixed inset-y-0 left-0 z-50 h-screen w-[280px] border-r border-slate-200 bg-white shadow-xl transition-transform duration-300 ease-out lg:translate-x-0 ${isSidebarOpen ? "translate-x-0" : "-translate-x-full"
            }`}
        >
          <OwnerSidebar onClose={() => setIsSidebarOpen(false)} />
        </aside>

        <div className="min-h-[125vh] lg:pl-[280px]">
          <OwnerHeader
            onLogout={onLogout}
            onMenuClick={() => setIsSidebarOpen(true)}
            userProfile={userProfile}
          />

          <main className="px-4 py-6 sm:px-6 lg:px-8">
            <div className="mx-auto max-w-[1540px]">
              <Outlet />
            </div>
          </main>
        </div>
      </div>
    </OwnerManproProvider>
  );
};

export default OwnerLayout;
